import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllResources } from "../../../../slices/ResourcesSlice";
import "../../../../styles/screens/client-visit-details/manage-module/EventsList.css";
import ResourcesListTable from "./ResourcesListTable";

function ResourcesList() {
  const dispatch = useDispatch();

  const selectedOfficeId = useSelector(
    (state) => state.officelist.selectedOfficeId
  );

  useEffect(() => {
    dispatch(getAllResources(selectedOfficeId));
  }, [selectedOfficeId]);

  return (
    <div className="events-list-container">
      <div className="events-list-content">
        <ResourcesListTable />
      </div>
    </div>
  );
}
export default ResourcesList;
